import { baseApi, PaginatedResponse } from 'sama-shared';
import type { DeliveryProvider } from '../../types/admin';
import type { GetDeliveryProvidersParams } from '../../types/api';
import type { CreateDeliveryProviderDto, UpdateDeliveryProviderDto } from '../../types/dto';

export const deliveryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeliveryProviders: builder.query<
      PaginatedResponse<DeliveryProvider>,
      GetDeliveryProvidersParams | void
    >({
      query: (params) => ({
        url: '/admin/delivery-provider',
        method: 'GET',
        params: params || {},
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'DeliveryProvider' as const, id })),
              { type: 'DeliveryProvider', id: 'LIST' },
            ]
          : [{ type: 'DeliveryProvider', id: 'LIST' }],
    }),

    getDeliveryProviderById: builder.query<DeliveryProvider, string>({
      query: (id) => ({
        url: `/admin/delivery-provider/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'DeliveryProvider', id }],
    }),

    createDeliveryProvider: builder.mutation<DeliveryProvider, CreateDeliveryProviderDto>({
      query: (newProvider) => ({
        url: '/admin/delivery-provider',
        method: 'POST',
        body: newProvider,
      }),
      invalidatesTags: [{ type: 'DeliveryProvider', id: 'LIST' }],
    }),

    updateDeliveryProvider: builder.mutation<
      DeliveryProvider,
      { id: string; body: UpdateDeliveryProviderDto }
    >({
      query: ({ id, body }) => ({
        url: `/admin/delivery-provider/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'DeliveryProvider', id },
        { type: 'DeliveryProvider', id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDeliveryProvidersQuery,
  useGetDeliveryProviderByIdQuery,
  useCreateDeliveryProviderMutation,
  useUpdateDeliveryProviderMutation,
} = deliveryApi;
